;(function () {

"use strict";

var PageView = Backbone.View.extend({
  initialize: function () {
    console.log('install page view init');
  },
  buildQueryString() {
    var permissions = [];
    var $checkboxes = this.$el.find('input[type="checkbox"]');
    var allChecked = true;

    $checkboxes.each(function () {
      var checked = $(this).is(':checked');
      if (checked) {
        permissions.push($(this).val());
      } else {
        allChecked = false;
      }
    });

    if (permissions.length === 0) {
      $checkboxes.prop('checked', true);
    }

    var scope = permissions.join(',');

    if (allChecked) {
      scope = '';
    }

    this.$el.find('input[name="scope"]').val(scope);
  },
  events: {
    'change input[type="checkbox"]': function(e) {
      console.log('building query string');
      this.buildQueryString();
    }
  }
});

module.exports = PageView;


}());